import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs/Subject';
import { HttpClient } from '@angular/common/http';
import * as hello from 'hellojs';

import { environment } from '../../../../../environments/environment';
import { AppGlobal } from 'src/app/app.global';

@Injectable()
export class TokenService {

  public http: HttpClient;

  private valueminer = this.initService();

  private reloadObservable: Subject<any>;

  public get(): Observable<string> {
    if (environment.isMobile || environment.customLogin) {
      AppGlobal.getToken.next();
      return AppGlobal.tokenObs.take(1);
    } else {
      if (this.valueminer === undefined || this.valueminer === null) {
        this.valueminer = this.initService();
      } else {
        const token = this.valueminer.login({ force: false, display: 'page' }).then(() => <string> this.valueminer.getAuthResponse().access_token);
        const promise = Promise.resolve(token);   // Abstraction to make the promise compatible
        return <Observable<string>> Observable.fromPromise(promise);
      }
    }
  }

  public refresh(): Observable<string> {
    if (environment.customLogin) {
      /* Check if login credentials are there */
      if (localStorage.getItem('valueminer.authentication') === null) {
        const helloLocal = localStorage.getItem('hello');
        const helloJSON = helloLocal !== null ? JSON.parse(helloLocal) : {};
        if (helloJSON['valueminer'] !== undefined && helloJSON['valueminer']['access_token'] !== undefined) {
          delete helloJSON['valueminer']['access_token'];
        }
        localStorage.setItem('hello', JSON.stringify(helloJSON));
        return this.get();
      } else {
        /* Data */
        const url = environment.go + '/authorisation/token';
        const body = localStorage.getItem('valueminer.authentication');
        /* Headers */
        const headers = { 'Accept': 'application/vnd.api.v2+json', 'Content-Type': 'application/json' };
        /* Send request */
        if (this.reloadObservable === undefined) {
          this.reloadObservable = new Subject();
          this.http.request('POST', url, { headers, body, responseType: 'json' }).subscribe(token => {
            const helloLocal = localStorage.getItem('hello');
            const helloJSON = helloLocal !== null ? JSON.parse(helloLocal) : {};
            if (helloJSON['valueminer'] === undefined) {
              helloJSON['valueminer'] = {};
            }
            helloJSON['valueminer']['access_token'] = token;
            localStorage.setItem('hello', JSON.stringify(helloJSON));
            this.reloadObservable.next(token);
            this.reloadObservable = undefined;
          });
        }
        return this.reloadObservable;
      }
    } else if (environment.isMobile) {
      if (localStorage.getItem('valueminer.mobile-token') !== null) {
        localStorage.removeItem('valueminer.mobile-token');
      }
      return this.get();
    } else {
      const token = this.valueminer.login({force: true, display: 'page'})
        .then(() => <string>this.valueminer.getAuthResponse().access_token);
      const promise = Promise.resolve(token);   // Abstraction to make the promise compatible
      return <Observable<string>>Observable.fromPromise(promise);
    }
  }

  private initService() {
    if (environment.isMobile || environment.customLogin) {
      return null;
    }
    hello.init({
      valueminer: {
        name: 'ValueMiner',
        oauth: {
          version: 2,
          auth: environment.auth.authurl,
          grant: environment.auth.tokenurl
        },
        display: 'page',
        refresh: true,
        scope: {
          api: 'api',
          users: 'users'
        },
        scope_delim: ' '
      }
    });

    hello.init(
      { valueminer: environment.auth.clientID },
      { scope: environment.auth.scopes.join(',') }
    );
    return hello('valueminer');
  }
}
